const HIDDEN_MARKETPLACES_IN_UI = new Set(["GAME_TIME", "TICKET_EVOLUTION"]);

const normalizeMarketplaceValue = (value: string | null | undefined): string =>
	(value ?? "").trim().toUpperCase();

export const isMarketplaceHiddenInUi = (value: string | null | undefined): boolean =>
	HIDDEN_MARKETPLACES_IN_UI.has(normalizeMarketplaceValue(value));

export const sanitizeMarketplaceForUi = (value: string | null | undefined): string =>
	isMarketplaceHiddenInUi(value) ? "" : (value ?? "");

export const filterVisibleMarketplaceOptions = <T extends { value: string }>(options: Array<T>): Array<T> =>
	options.filter((option) => !isMarketplaceHiddenInUi(option.value));
